import React from 'react';
import SectionCard from '../components/SectionCard';

export default function TrendsSection({ trends = [] }) {
  if (!trends || trends.length === 0) return null;
  return (
    <SectionCard title="📈 Tendances détectées">
      <ul style={styles.list}>
        {trends.map((t, i) => (
          <li key={i} style={styles.item}>
            <span style={styles.bullet} aria-hidden />
            <span>{t}</span>
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}

const styles = {
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    fontSize: 14,
    color: '#1A1A1A',
    lineHeight: 1.5,
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#E8502A',
    marginTop: 8,
    flexShrink: 0,
  },
};
